import { User } from "@lognote/common";
import { InjectionKey, Ref } from "vue";

export const UserKey = Symbol() as InjectionKey<Ref<User>>;
